import React, {useState} from "react";
import Popup from "../../../../component/Popup/Popup";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {Button} from "react-bootstrap";

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import InputsdLogBook from "./InputsdLogBook";
import LogBookItemList from "./LogBookItemList";

export default function PopupLogBook({item}) {

    const [itens, setItens] = useState([]);
    const [lgShow, setLgShow] = useState(false);
    const [loadItens, setLoadItens] = useState(true);
    const [showInputs, setShowInputs] = useState(false);


    const button = <>
        <CalendarMonthIcon fontSize="medium"/>
        &nbsp; Diário de bordo
    </>

    const title = "Diário de bordo"

    const iconSpan = <>
        <CalendarMonthIcon fontSize="large" id="icon-svg"/>
        <h3>{title}</h3>
    </>

    return <Popup
        buttonText={button}
        title={title}
        iconSpan={iconSpan}
        lgShow={lgShow} setLgShow={setLgShow}
        buttonClass={'dropdown-item'}
    >
        <div style={{width: '80%', margin: '0 10%'}}>

            <Button className='text-end button-show '
                    onClick={() => {
                        setShowInputs(prevValue => !prevValue)
                    }}>
                {showInputs ?
                    <>Cancelar <CloseIcon fontSize="medium"/></> :
                    <>Adicionar <AddIcon fontSize="medium"/></>
                }
            </Button>

            <div style={{padding: '1% 0 0 0 '}} className={''}>
                <h5>Lote: {item.numero} - {item.evento.nomeEvento}</h5>
            </div>
            <hr/>

            {showInputs && <>
                <InputsdLogBook
                    pedidoId={item.id} setLoadItens={setLoadItens}
                    setShowInputs={setShowInputs}
                />
                <hr/>
            </>}

            <LogBookItemList
                itens={itens} setItens={setItens}
                loadItens={loadItens} setLoadItens={setLoadItens}
                pedidoId={item.id}
            />
        </div>
        <br/>
    </Popup>
}